import type { MetricCardType } from "@/components/MetricCard/MetricCard.types";
import { formatDate } from "@/pages/_layouts/jobs/_utils";
import type { Path } from "@/router";

export type CompensationProfileMetricsInput = {
  isSnapshot?: boolean | null;
  contactLastModifiedDate?: string | null;
  updatedAt?: string | null;
  lastModificationSource?: string | null;
};

export type BuildCompensationProfileMetricsOptions = {
  includeStatus?: boolean;
};

function overallLastModifiedLabel(source?: string | null): string {
  const resolvedSource = source || "Unknown";
  return resolvedSource === "Person" ? "Overall Last Modified" : `Last Modified by ${resolvedSource}`;
}

export function buildCompensationProfileMetrics(
  profile: CompensationProfileMetricsInput | null | undefined,
  loading: boolean,
  { includeStatus = true }: BuildCompensationProfileMetricsOptions = {}
): MetricCardType<Path>[] {
  const contactLastModifiedDate = profile?.contactLastModifiedDate;

  const metrics: MetricCardType<Path>[] = [];

  if (includeStatus) {
    metrics.push({
      label: "Profile Status",
      value: profile?.isSnapshot ? "Inactive" : "Active",
      iconName: profile?.isSnapshot ? "pause_circle" : "check_circle",
      loading,
      testId: "compensation-profile-status-metric"
    });
  }

  metrics.push(
    {
      label: "Last Modified by Person",
      value: contactLastModifiedDate ? formatDate(contactLastModifiedDate) : null,
      iconName: "today",
      loading,
      testId: "compensation-profile-contact-last-modified-metric"
    },
    {
      label: overallLastModifiedLabel(profile?.lastModificationSource),
      value: profile?.updatedAt ? formatDate(profile.updatedAt) : null,
      iconName: "today",
      loading,
      testId: "compensation-profile-last-modified-metric"
    }
  );

  return metrics;
}
